import { sessionStore } from '../Store/sessionStore';

const CLINIC_TOKEN_KEY = 'clinicAccessToken';
const CLINIC_DETAILS_KEY = 'clinicDetails';
const AUTH_FLOW_STATE_KEYS = ['clinicSignupVerify', 'clinicPasswordReset'];

export const setClinicAccessToken = (token) => {
    if (!token) return;
    localStorage.setItem(CLINIC_TOKEN_KEY, token);
    sessionStore.reset();
};

export const getClinicAccessToken = () => localStorage.getItem(CLINIC_TOKEN_KEY);

export const clearClinicAccessToken = () => localStorage.removeItem(CLINIC_TOKEN_KEY);

export const isTokenExpired = () => {
    const token = getClinicAccessToken();
    if (!token) return true;
    try {
        const { exp } = JSON.parse(atob(token.split('.')[1]));
        return Date.now() >= exp * 1000;
    } catch {
        return true;
    }
};

export const isClinicAuthenticated = () => Boolean(getClinicAccessToken()) && !isTokenExpired();

export const setClinicDetails = (details) => details && localStorage.setItem(CLINIC_DETAILS_KEY, JSON.stringify(details));

export const getClinicDetails = () => {
    const stored = localStorage.getItem(CLINIC_DETAILS_KEY);
    return stored ? JSON.parse(stored) : null;
};

export const clearClinicDetails = () => localStorage.removeItem(CLINIC_DETAILS_KEY);

export const clearClinicSession = () => {
    clearClinicAccessToken();
    clearClinicDetails();
    AUTH_FLOW_STATE_KEYS.forEach((key) => sessionStorage.removeItem(key));
};
